module.exports = [
	{
		"name": "furniture",
		"qualifiedName": "furniture",
		"displayName": "Furniture",
		"children": [
			{
				"name": "sofaSets",
				"qualifiedName": "furniture.sofaSets",
				"displayName": "Sofa sets",
				"children": [
					{
						"name": "1Seat",
						"qualifiedName": "furniture.sofaSets.1Seat",
						"displayName": "1 seat",
						"children": [
							{
								"name": "leather",
								"qualifiedName": "furniture.sofaSets.1Seat.leather",
								"displayName": "Leather",
								"children": [
									{
										"name": "recliner",
										"qualifiedName": "furniture.sofaSets.1Seat.leather.recliner",
										"displayName": "Recliner",
										"children": [],
										"score": 0,
										"description": "1 seater leather recliner sofa set",
										"identifier": 1,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 35
									},
									{
										"name": "nonRecliner",
										"qualifiedName": "furniture.sofaSets.1Seat.leather.nonRecliner",
										"displayName": "Non recliner",
										"children": [],
										"score": 1,
										"description": "1 seater leather non recliner sofa set",
										"identifier": 2,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 30
									}
								],
								"score": 0
							},
							{
								"name": "wooden",
								"qualifiedName": "furniture.sofaSets.1Seat.wooden",
								"displayName": "Wooden",
								"children": [
									{
										"name": "withStorage",
										"qualifiedName": "furniture.sofaSets.1Seat.wooden.withStorage",
										"displayName": "With storage",
										"children": [],
										"score": 2,
										"description": "1 seater wooden sofa set with storage",
										"identifier": 3,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 25
									},
									{
										"name": "withoutStorage",
										"qualifiedName": "furniture.sofaSets.1Seat.wooden.withoutStorage",
										"displayName": "Without storage",
										"children": [],
										"score": 3,
										"description": "1 seater wooden sofa set without storage",
										"identifier": 4,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 25
									}
								],
								"score": 2
							},
							{
								"name": "fabric",
								"qualifiedName": "furniture.sofaSets.1Seat.fabric",
								"displayName": "Fabric",
								"children": [
									{
										"name": "recliner",
										"qualifiedName": "furniture.sofaSets.1Seat.fabric.recliner",
										"displayName": "Recliner",
										"children": [],
										"score": 4,
										"description": "1 seater fabric recliner sofa set",
										"identifier": 5,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 35
									},
									{
										"name": "nonRecliner",
										"qualifiedName": "furniture.sofaSets.1Seat.fabric.nonRecliner",
										"displayName": "Non recliner",
										"children": [],
										"score": 5,
										"description": "1 seater fabric non recliner sofa set",
										"identifier": 6,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 30
									}
								],
								"score": 4
							},
							{
								"name": "cane",
								"qualifiedName": "furniture.sofaSets.1Seat.cane",
								"displayName": "Cane",
								"children": [],
								"score": 6,
								"description": "1 seater cane sofa set",
								"identifier": 7,
								"item_id": 39,
								"version": "2",
								"cubic_feet": 20
							}
						],
						"score": 0
					},
					{
						"name": "2Seats",
						"qualifiedName": "furniture.sofaSets.2Seats",
						"displayName": "2 seats",
						"children": [
							{
								"name": "2",
								"qualifiedName": "furniture.sofaSets.2Seats.2",
								"displayName": "2",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.2Seats.2.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.2Seats.2.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 7,
												"description": "2 seater leather recliner sofa set",
												"identifier": 8,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 50
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.2Seats.2.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 8,
												"description": "2 seater leather non recliner sofa set",
												"identifier": 9,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 40
											}
										],
										"score": 7
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.2Seats.2.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.2Seats.2.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 9,
												"description": "2 seater wooden sofa set with storage",
												"identifier": 10,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 30
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.2Seats.2.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 10,
												"description": "2 seater wooden sofa set without storage",
												"identifier": 11,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 35
											}
										],
										"score": 9
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.2Seats.2.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.2Seats.2.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 11,
												"description": "2 seater fabric recliner sofa set",
												"identifier": 12,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 40
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.2Seats.2.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 12,
												"description": "2 seater fabric non recliner sofa set",
												"identifier": 13,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 35
											}
										],
										"score": 11
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.2Seats.2.cane",
										"displayName": "Cane",
										"children": [],
										"score": 13,
										"description": "2 seater cane sofa set",
										"identifier": 14,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 30
									}
								],
								"score": 7
							},
							{
								"name": "11",
								"qualifiedName": "furniture.sofaSets.2Seats.11",
								"displayName": "1+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.2Seats.11.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.2Seats.11.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 14,
												"description": "1+1 leather recliner sofa set",
												"identifier": 15,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 70
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.2Seats.11.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 15,
												"description": "1+1 leather non recliner sofa set",
												"identifier": 16,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 60
											}
										],
										"score": 14
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.2Seats.11.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.2Seats.11.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 16,
												"description": "1+1 wooden sofa set with storage",
												"identifier": 17,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 60
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.2Seats.11.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 17,
												"description": "1+1 wooden sofa set without storage",
												"identifier": 18,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 50
											}
										],
										"score": 16
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.2Seats.11.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.2Seats.11.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 18,
												"description": "1+1 fabric recliner sofa set",
												"identifier": 19,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 70
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.2Seats.11.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 19,
												"description": "1+1 fabric non recliner sofa set",
												"identifier": 20,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 60
											}
										],
										"score": 18
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.2Seats.11.cane",
										"displayName": "Cane",
										"children": [],
										"score": 20,
										"description": "1+1 cane sofa set",
										"identifier": 21,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 40
									}
								],
								"score": 14
							}
						],
						"score": 7
					},
					{
						"name": "3Seats",
						"qualifiedName": "furniture.sofaSets.3Seats",
						"displayName": "3 seats",
						"children": [
							{
								"name": "3",
								"qualifiedName": "furniture.sofaSets.3Seats.3",
								"displayName": "3",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.3Seats.3.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.3Seats.3.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 21,
												"description": "3 seater leather recliner sofa set",
												"identifier": 22,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 65
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.3Seats.3.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 22,
												"description": "3 seater leather non recliner sofa set",
												"identifier": 23,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 60
											}
										],
										"score": 21
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.3Seats.3.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.3Seats.3.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 23,
												"description": "3 seater wooden sofa set with storage",
												"identifier": 24,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 55
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.3Seats.3.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 24,
												"description": "3 seater wooden sofa set without storage",
												"identifier": 25,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 50
											}
										],
										"score": 23
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.3Seats.3.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.3Seats.3.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 25,
												"description": "3 seater fabric recliner sofa set",
												"identifier": 26,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 65
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.3Seats.3.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 26,
												"description": "3 seater fabric non recliner sofa set",
												"identifier": 27,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 60
											}
										],
										"score": 25
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.3Seats.3.cane",
										"displayName": "Cane",
										"children": [],
										"score": 27,
										"description": "3 seater cane sofa set",
										"identifier": 28,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 45
									}
								],
								"score": 21
							},
							{
								"name": "21",
								"qualifiedName": "furniture.sofaSets.3Seats.21",
								"displayName": "2+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.3Seats.21.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.3Seats.21.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 28,
												"description": "2+1 leather recliner sofa set",
												"identifier": 29,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 85
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.3Seats.21.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 29,
												"description": "2+1 leather non recliner sofa set",
												"identifier": 30,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 28
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.3Seats.21.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.3Seats.21.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 30,
												"description": "2+1 wooden sofa set with storage",
												"identifier": 31,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 75
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.3Seats.21.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 31,
												"description": "2+1 wooden sofa set without storage",
												"identifier": 32,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 30
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.3Seats.21.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.3Seats.21.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 32,
												"description": "2+1 fabric recliner sofa set",
												"identifier": 33,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 85
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.3Seats.21.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 33,
												"description": "2+1 fabric non recliner sofa set",
												"identifier": 34,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 32
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.3Seats.21.cane",
										"displayName": "Cane",
										"children": [],
										"score": 34,
										"description": "2+1 cane sofa set",
										"identifier": 35,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 55
									}
								],
								"score": 28
							}
						],
						"score": 21
					},
					{
						"name": "4Seats",
						"qualifiedName": "furniture.sofaSets.4Seats",
						"displayName": "4 seats",
						"children": [
							{
								"name": "31",
								"qualifiedName": "furniture.sofaSets.4Seats.31",
								"displayName": "3+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.4Seats.31.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.31.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 35,
												"description": "3+1 leather recliner sofa set",
												"identifier": 36,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.31.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 36,
												"description": "3+1 leather non recliner sofa set",
												"identifier": 37,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											}
										],
										"score": 35
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.4Seats.31.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.31.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 37,
												"description": "3+1 wooden sofa set with storage",
												"identifier": 38,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.31.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 38,
												"description": "3+1 wooden sofa set without storage",
												"identifier": 39,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 95
											}
										],
										"score": 37
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.4Seats.31.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.31.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 39,
												"description": "3+1 fabric recliner sofa set",
												"identifier": 40,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.31.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 40,
												"description": "3+1 fabric non recliner sofa set",
												"identifier": 41,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											}
										],
										"score": 39
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.4Seats.31.cane",
										"displayName": "Cane",
										"children": [],
										"score": 41,
										"description": "3+1 cane sofa set",
										"identifier": 42,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 70
									}
								],
								"score": 35
							},
							{
								"name": "22",
								"qualifiedName": "furniture.sofaSets.4Seats.22",
								"displayName": "2+2",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.4Seats.22.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.22.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 42,
												"description": "2+2 leather recliner sofa set",
												"identifier": 43,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 100
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.22.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 43,
												"description": "2+2 leather non recliner sofa set",
												"identifier": 44,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											}
										],
										"score": 42
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.4Seats.22.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.22.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 44,
												"description": "2+2 wooden sofa set with storage",
												"identifier": 45,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.22.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 45,
												"description": "2+2 wooden sofa set without storage",
												"identifier": 46,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 44
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.4Seats.22.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.22.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 46,
												"description": "2+2 fabric recliner sofa set",
												"identifier": 47,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 100
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.22.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 47,
												"description": "2+2 fabric non recliner sofa set",
												"identifier": 48,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											}
										],
										"score": 46
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.4Seats.22.cane",
										"displayName": "Cane",
										"children": [],
										"score": 48,
										"description": "2+2 cane sofa set",
										"identifier": 49,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 70
									}
								],
								"score": 42
							},
							{
								"name": "211",
								"qualifiedName": "furniture.sofaSets.4Seats.211",
								"displayName": "2+1+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.4Seats.211.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.211.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 49,
												"description": "2+1+1 leather recliner sofa set",
												"identifier": 50,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.211.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 50,
												"description": "2+1+1 leather non recliner sofa set",
												"identifier": 51,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											}
										],
										"score": 49
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.4Seats.211.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.211.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 51,
												"description": "2+1+1 wooden sofa set with storage",
												"identifier": 52,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.211.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 52,
												"description": "2+1+1 wooden sofa set without storage",
												"identifier": 53,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 51
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.4Seats.211.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.211.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 53,
												"description": "2+1+1 fabric recliner sofa set",
												"identifier": 54,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.211.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 54,
												"description": "2+1+1 fabric non recliner sofa set",
												"identifier": 55,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											}
										],
										"score": 53
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.4Seats.211.cane",
										"displayName": "Cane",
										"children": [],
										"score": 55,
										"description": "2+1+1 cane sofa set",
										"identifier": 56,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 75
									}
								],
								"score": 49
							},
							{
								"name": "4",
								"qualifiedName": "furniture.sofaSets.4Seats.4",
								"displayName": "4",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.4Seats.4.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.4.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 56,
												"description": "4 seater leather recliner sofa set",
												"identifier": 57,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.4.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 57,
												"description": "4 seater leather non recliner sofa set",
												"identifier": 58,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 80
											}
										],
										"score": 56
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.4Seats.4.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.4.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 58,
												"description": "4 seater wooden sofa set with storage",
												"identifier": 59,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 75
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.4Seats.4.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 59,
												"description": "4 seater wooden sofa set without storage",
												"identifier": 60,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 70
											}
										],
										"score": 58
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.4Seats.4.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.4Seats.4.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 60,
												"description": "4 seater fabric recliner sofa set",
												"identifier": 61,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 90
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.4Seats.4.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 61,
												"description": "4 seater fabric non recliner sofa set",
												"identifier": 62,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 80
											}
										],
										"score": 60
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.4Seats.4.cane",
										"displayName": "Cane",
										"children": [],
										"score": 62,
										"description": "4 seater cane sofa set",
										"identifier": 63,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 60
									}
								],
								"score": 56
							}
						],
						"score": 35
					},
					{
						"name": "5Seats",
						"qualifiedName": "furniture.sofaSets.5Seats",
						"displayName": "5 seats",
						"children": [
							{
								"name": "41",
								"qualifiedName": "furniture.sofaSets.5Seats.41",
								"displayName": "4+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.5Seats.41.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.41.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 63,
												"description": "4+1 leather recliner sofa set",
												"identifier": 64,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 125
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.41.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 64,
												"description": "4+1 leather non recliner sofa set",
												"identifier": 65,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 110
											}
										],
										"score": 63
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.5Seats.41.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.41.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 65,
												"description": "4+1 wooden sofa set with storage",
												"identifier": 66,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 110
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.41.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 66,
												"description": "4+1 wooden sofa set without storage",
												"identifier": 67,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 115
											}
										],
										"score": 65
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.5Seats.41.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.41.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 67,
												"description": "4+1 fabric recliner sofa set",
												"identifier": 68,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 115
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.41.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 68,
												"description": "4+1 fabric non recliner sofa set",
												"identifier": 69,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 67
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.5Seats.41.cane",
										"displayName": "Cane",
										"children": [],
										"score": 69,
										"description": "4+1 cane sofa set",
										"identifier": 70,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 80
									}
								],
								"score": 63
							},
							{
								"name": "221",
								"qualifiedName": "furniture.sofaSets.5Seats.221",
								"displayName": "2+2+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.5Seats.221.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.221.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 70,
												"description": "2+2+1 leather recliner sofa set",
												"identifier": 71,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 135
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.221.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 71,
												"description": "2+2+1 leather non recliner sofa set",
												"identifier": 72,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 70
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.5Seats.221.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.221.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 72,
												"description": "2+2+1 wooden sofa set with storage",
												"identifier": 73,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.221.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 73,
												"description": "2+2+1 wooden sofa set without storage",
												"identifier": 74,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 125
											}
										],
										"score": 72
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.5Seats.221.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.221.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 74,
												"description": "2+2+1 fabric recliner sofa set",
												"identifier": 75,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 135
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.221.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 75,
												"description": "2+2+1 fabric non recliner sofa set",
												"identifier": 76,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 74
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.5Seats.221.cane",
										"displayName": "Cane",
										"children": [],
										"score": 76,
										"description": "2+2+1 cane sofa set",
										"identifier": 77,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 90
									}
								],
								"score": 70
							},
							{
								"name": "311",
								"qualifiedName": "furniture.sofaSets.5Seats.311",
								"displayName": "3+1+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.5Seats.311.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.311.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 77,
												"description": "3+1+1 leather recliner sofa set",
												"identifier": 78,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.311.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 78,
												"description": "3+1+1 leather non recliner sofa set",
												"identifier": 79,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 77
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.5Seats.311.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.311.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 79,
												"description": "3+1+1 wooden sofa set with storage",
												"identifier": 80,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.311.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 80,
												"description": "3+1+1 wooden sofa set without storage",
												"identifier": 81,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 79
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.5Seats.311.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.311.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 81,
												"description": "3+1+1 fabric recliner sofa set",
												"identifier": 82,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.311.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 82,
												"description": "3+1+1 fabric non recliner sofa set",
												"identifier": 83,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 81
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.5Seats.311.cane",
										"displayName": "Cane",
										"children": [],
										"score": 83,
										"description": "3+1+1 cane sofa set",
										"identifier": 84,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 90
									}
								],
								"score": 77
							},
							{
								"name": "32",
								"qualifiedName": "furniture.sofaSets.5Seats.32",
								"displayName": "3+2",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.5Seats.32.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.32.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 84,
												"description": "3+2 leather recliner sofa set",
												"identifier": 85,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.32.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 85,
												"description": "3+2 leather non recliner sofa set",
												"identifier": 86,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											}
										],
										"score": 84
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.5Seats.32.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.32.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 86,
												"description": "3+2 wooden sofa set with storage",
												"identifier": 87,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.5Seats.32.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 87,
												"description": "3+2 wooden sofa set without storage",
												"identifier": 88,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 86
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.5Seats.32.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.5Seats.32.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 88,
												"description": "3+2 fabric recliner sofa set",
												"identifier": 89,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 120
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.5Seats.32.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 89,
												"description": "3+2 fabric non recliner sofa set",
												"identifier": 90,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 105
											}
										],
										"score": 88
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.5Seats.32.cane",
										"displayName": "Cane",
										"children": [],
										"score": 90,
										"description": "3+2 cane sofa set",
										"identifier": 91,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 85
									}
								],
								"score": 84
							}
						],
						"score": 63
					},
					{
						"name": "6Seats",
						"qualifiedName": "furniture.sofaSets.6Seats",
						"displayName": "6 seats",
						"children": [
							{
								"name": "42",
								"qualifiedName": "furniture.sofaSets.6Seats.42",
								"displayName": "4+2",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.6Seats.42.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.42.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 91,
												"description": "4+2 leather recliner sofa set",
												"identifier": 92,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.42.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 92,
												"description": "4+2 leather non recliner sofa set",
												"identifier": 93,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 125
											}
										],
										"score": 91
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.6Seats.42.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.42.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 93,
												"description": "4+2 wooden sofa set with storage",
												"identifier": 94,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 125
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.42.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 94,
												"description": "4+2 wooden sofa set without storage",
												"identifier": 95,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											}
										],
										"score": 93
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.6Seats.42.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.42.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 95,
												"description": "4+2 fabric recliner sofa set",
												"identifier": 96,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 130
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.42.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 96,
												"description": "4+2 fabric non recliner sofa set",
												"identifier": 97,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 115
											}
										],
										"score": 95
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.6Seats.42.cane",
										"displayName": "Cane",
										"children": [],
										"score": 97,
										"description": "4+2 cane sofa set",
										"identifier": 98,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 95
									}
								],
								"score": 91
							},
							{
								"name": "411",
								"qualifiedName": "furniture.sofaSets.6Seats.411",
								"displayName": "4+1+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.6Seats.411.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.411.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 98,
												"description": "4+1+1 leather recliner sofa set",
												"identifier": 99,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 160
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.411.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 99,
												"description": "4+1+1 leather non recliner sofa set",
												"identifier": 100,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											}
										],
										"score": 98
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.6Seats.411.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.411.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 100,
												"description": "4+1+1 wooden sofa set with storage",
												"identifier": 101,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.411.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 101,
												"description": "4+1+1 wooden sofa set without storage",
												"identifier": 102,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 140
											}
										],
										"score": 100
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.6Seats.411.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.411.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 102,
												"description": "4+1+1 fabric recliner sofa set",
												"identifier": 103,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 150
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.411.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 103,
												"description": "4+1+1 fabric non recliner sofa set",
												"identifier": 104,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 130
											}
										],
										"score": 102
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.6Seats.411.cane",
										"displayName": "Cane",
										"children": [],
										"score": 104,
										"description": "4+1+1 cane sofa set",
										"identifier": 105,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 100
									}
								],
								"score": 98
							},
							{
								"name": "321",
								"qualifiedName": "furniture.sofaSets.6Seats.321",
								"displayName": "3+2+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.6Seats.321.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.321.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 105,
												"description": "3+2+1 leather recliner sofa set",
												"identifier": 106,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 155
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.321.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 106,
												"description": "3+2+1 leather non recliner sofa set",
												"identifier": 107,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 135
											}
										],
										"score": 105
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.6Seats.321.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.321.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 107,
												"description": "3+2+1 wooden sofa set with storage",
												"identifier": 108,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 135
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.321.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 108,
												"description": "3+2+1 wooden sofa set without storage",
												"identifier": 109,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 145
											}
										],
										"score": 107
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.6Seats.321.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.321.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 109,
												"description": "3+2+1 fabric recliner sofa set",
												"identifier": 110,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 155
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.321.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 110,
												"description": "3+2+1 fabric non recliner sofa set",
												"identifier": 111,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 135
											}
										],
										"score": 109
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.6Seats.321.cane",
										"displayName": "Cane",
										"children": [],
										"score": 111,
										"description": "3+2+1 cane sofa set",
										"identifier": 112,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 105
									}
								],
								"score": 105
							},
							{
								"name": "2211",
								"qualifiedName": "furniture.sofaSets.6Seats.2211",
								"displayName": "2+2+1+1",
								"children": [
									{
										"name": "leather",
										"qualifiedName": "furniture.sofaSets.6Seats.2211.leather",
										"displayName": "Leather",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.2211.leather.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 112,
												"description": "2+2+1+1 leather recliner sofa set",
												"identifier": 113,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 170
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.2211.leather.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 113,
												"description": "2+2+1+1 leather non recliner sofa set",
												"identifier": 114,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 150
											}
										],
										"score": 112
									},
									{
										"name": "wooden",
										"qualifiedName": "furniture.sofaSets.6Seats.2211.wooden",
										"displayName": "Wooden",
										"children": [
											{
												"name": "withStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.2211.wooden.withStorage",
												"displayName": "With storage",
												"children": [],
												"score": 114,
												"description": "2+2+1+1 wooden sofa set with storage",
												"identifier": 115,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 150
											},
											{
												"name": "withoutStorage",
												"qualifiedName": "furniture.sofaSets.6Seats.2211.wooden.withoutStorage",
												"displayName": "Without storage",
												"children": [],
												"score": 115,
												"description": "2+2+1+1 wooden sofa set without storage",
												"identifier": 116,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 150
											}
										],
										"score": 114
									},
									{
										"name": "fabric",
										"qualifiedName": "furniture.sofaSets.6Seats.2211.fabric",
										"displayName": "Fabric",
										"children": [
											{
												"name": "recliner",
												"qualifiedName": "furniture.sofaSets.6Seats.2211.fabric.recliner",
												"displayName": "Recliner",
												"children": [],
												"score": 116,
												"description": "2+2+1+1 fabric recliner sofa set",
												"identifier": 117,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 170
											},
											{
												"name": "nonRecliner",
												"qualifiedName": "furniture.sofaSets.6Seats.2211.fabric.nonRecliner",
												"displayName": "Non recliner",
												"children": [],
												"score": 117,
												"description": "2+2+1+1 fabric non recliner sofa set",
												"identifier": 118,
												"item_id": 39,
												"version": "2",
												"cubic_feet": 150
											}
										],
										"score": 116
									},
									{
										"name": "cane",
										"qualifiedName": "furniture.sofaSets.6Seats.2211.cane",
										"displayName": "Cane",
										"children": [],
										"score": 118,
										"description": "2+2+1+1 cane sofa set",
										"identifier": 119,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 110
									}
								],
								"score": 112
							}
						],
						"score": 91
					},
					{
						"name": "7Seats",
						"qualifiedName": "furniture.sofaSets.7Seats",
						"displayName": "7+ seats",
						"children": [
							{
								"name": "leather",
								"qualifiedName": "furniture.sofaSets.7Seats.leather",
								"displayName": "Leather",
								"children": [
									{
										"name": "recliner",
										"qualifiedName": "furniture.sofaSets.7Seats.leather.recliner",
										"displayName": "Recliner",
										"children": [],
										"score": 119,
										"description": "7+ seater recliner sofa set",
										"identifier": 120,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 180
									},
									{
										"name": "nonRecliner",
										"qualifiedName": "furniture.sofaSets.7Seats.leather.nonRecliner",
										"displayName": "Non recliner",
										"children": [],
										"score": 120,
										"description": "7+ seater non recliner sofa set",
										"identifier": 121,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 160
									}
								],
								"score": 119
							},
							{
								"name": "wooden",
								"qualifiedName": "furniture.sofaSets.7Seats.wooden",
								"displayName": "Wooden",
								"children": [
									{
										"name": "withStorage",
										"qualifiedName": "furniture.sofaSets.7Seats.wooden.withStorage",
										"displayName": "With storage",
										"children": [],
										"score": 121,
										"description": "7+ seater wooden sofa set with storage",
										"identifier": 122,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 150
									},
									{
										"name": "withoutStorage",
										"qualifiedName": "furniture.sofaSets.7Seats.wooden.withoutStorage",
										"displayName": "Without storage",
										"children": [],
										"score": 122,
										"description": "7+ seater wooden sofa set without storage",
										"identifier": 123,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 140
									}
								],
								"score": 121
							},
							{
								"name": "fabric",
								"qualifiedName": "furniture.sofaSets.7Seats.fabric",
								"displayName": "Fabric",
								"children": [
									{
										"name": "recliner",
										"qualifiedName": "furniture.sofaSets.7Seats.fabric.recliner",
										"displayName": "Recliner",
										"children": [],
										"score": 123,
										"description": "7+ seater recliner sofa set",
										"identifier": 124,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 180
									},
									{
										"name": "nonRecliner",
										"qualifiedName": "furniture.sofaSets.7Seats.fabric.nonRecliner",
										"displayName": "Non recliner",
										"children": [],
										"score": 124,
										"description": "7+ seater non recliner sofa set",
										"identifier": 125,
										"item_id": 39,
										"version": "2",
										"cubic_feet": 160
									}
								],
								"score": 123
							},
							{
								"name": "cane",
								"qualifiedName": "furniture.sofaSets.7Seats.cane",
								"displayName": "Cane",
								"children": [],
								"score": 125,
								"description": "7+ seater sofa set",
								"identifier": 126,
								"item_id": 39,
								"version": "2",
								"cubic_feet": 120
							}
						],
						"score": 119
					}
				],
				"score": 0,
				"item_id": 39
			},
			{
				"name": "tables",
				"qualifiedName": "furniture.tables",
				"displayName": "Tables",
				"children": [
					{
						"name": "coffeeCentre",
						"qualifiedName": "furniture.tables.coffeeCentre",
						"displayName": "Coffee / centre",
						"children": [
							{
								"name": "glassTop",
								"qualifiedName": "furniture.tables.coffeeCentre.glassTop",
								"displayName": "Glass top",
								"children": [],
								"score": 126,
								"description": "Glass top centre table",
								"identifier": 127,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "woodenTop",
								"qualifiedName": "furniture.tables.coffeeCentre.woodenTop",
								"displayName": "Wooden top",
								"children": [],
								"score": 127,
								"description": "Wooden top centre table",
								"identifier": 128,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 12
							}
						],
						"score": 126
					},
					{
						"name": "diningTable",
						"qualifiedName": "furniture.tables.diningTable",
						"displayName": "Dining Table",
						"children": [
							{
								"name": "2Seater",
								"qualifiedName": "furniture.tables.diningTable.2Seater",
								"displayName": "2 seater",
								"children": [
									{
										"name": "woodenTop",
										"qualifiedName": "furniture.tables.diningTable.2Seater.woodenTop",
										"displayName": "Wooden top",
										"children": [
											{
												"name": "dismantlable",
												"qualifiedName": "furniture.tables.diningTable.2Seater.woodenTop.dismantlable",
												"displayName": "Dismantlable",
												"children": [],
												"score": 128,
												"description": "2 seater dismantlable wooden top dining table",
												"identifier": 129,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 10
											},
											{
												"name": "nonhyphendismantlable",
												"qualifiedName": "furniture.tables.diningTable.2Seater.woodenTop.nonhyphendismantlable",
												"displayName": "Non-dismantlable",
												"children": [],
												"score": 129,
												"description": "2 seater non-dismantlable wooden top dining table",
												"identifier": 130,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 10
											}
										],
										"score": 128
									},
									{
										"name": "metalTop",
										"qualifiedName": "furniture.tables.diningTable.2Seater.metalTop",
										"displayName": "Metal top",
										"children": [
											{
												"name": "foldable",
												"qualifiedName": "furniture.tables.diningTable.2Seater.metalTop.foldable",
												"displayName": "Foldable",
												"children": [],
												"score": 130,
												"description": "2 seater foldable metal top dining table",
												"identifier": 131,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 10
											},
											{
												"name": "nonhyphenfoldable",
												"qualifiedName": "furniture.tables.diningTable.2Seater.metalTop.nonhyphenfoldable",
												"displayName": "Non-foldable",
												"children": [],
												"score": 131,
												"description": "2 seater non-foldable metal top dining table",
												"identifier": 132,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 12
											}
										],
										"score": 130
									},
									{
										"name": "glassTop",
										"qualifiedName": "furniture.tables.diningTable.2Seater.glassTop",
										"displayName": "Glass top",
										"children": [],
										"score": 132,
										"description": "2 seater glass top dining table",
										"identifier": 133,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 12
									}
								],
								"score": 128
							},
							{
								"name": "3Seater",
								"qualifiedName": "furniture.tables.diningTable.3Seater",
								"displayName": "3 seater",
								"children": [
									{
										"name": "woodenTop",
										"qualifiedName": "furniture.tables.diningTable.3Seater.woodenTop",
										"displayName": "Wooden top",
										"children": [
											{
												"name": "dismantlable",
												"qualifiedName": "furniture.tables.diningTable.3Seater.woodenTop.dismantlable",
												"displayName": "Dismantlable",
												"children": [],
												"score": 133,
												"description": "3 seater dismantlable wooden top dining table",
												"identifier": 134,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 15
											},
											{
												"name": "nonhyphendismantlable",
												"qualifiedName": "furniture.tables.diningTable.3Seater.woodenTop.nonhyphendismantlable",
												"displayName": "Non-dismantlable",
												"children": [],
												"score": 134,
												"description": "3 seater non-dismantlable wooden top dining table",
												"identifier": 135,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 17
											}
										],
										"score": 133
									},
									{
										"name": "metalTop",
										"qualifiedName": "furniture.tables.diningTable.3Seater.metalTop",
										"displayName": "Metal top",
										"children": [
											{
												"name": "foldable",
												"qualifiedName": "furniture.tables.diningTable.3Seater.metalTop.foldable",
												"displayName": "Foldable",
												"children": [],
												"score": 135,
												"description": "3 seater foldable metal top dining table",
												"identifier": 136,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 15
											},
											{
												"name": "nonhyphenfoldable",
												"qualifiedName": "furniture.tables.diningTable.3Seater.metalTop.nonhyphenfoldable",
												"displayName": "Non-foldable",
												"children": [],
												"score": 136,
												"description": "3 seater non-foldable metal top dining table",
												"identifier": 137,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 17
											}
										],
										"score": 135
									},
									{
										"name": "glassTop",
										"qualifiedName": "furniture.tables.diningTable.3Seater.glassTop",
										"displayName": "Glass top",
										"children": [],
										"score": 137,
										"description": "3 seater glass top dining table",
										"identifier": 138,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 17
									}
								],
								"score": 133
							},
							{
								"name": "4Seater",
								"qualifiedName": "furniture.tables.diningTable.4Seater",
								"displayName": "4 seater",
								"children": [
									{
										"name": "woodenTop",
										"qualifiedName": "furniture.tables.diningTable.4Seater.woodenTop",
										"displayName": "Wooden top",
										"children": [
											{
												"name": "dismantlable",
												"qualifiedName": "furniture.tables.diningTable.4Seater.woodenTop.dismantlable",
												"displayName": "Dismantlable",
												"children": [],
												"score": 138,
												"description": "4 seater dismantlable wooden top dining table",
												"identifier": 139,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 20
											},
											{
												"name": "nonhyphendismantlable",
												"qualifiedName": "furniture.tables.diningTable.4Seater.woodenTop.nonhyphendismantlable",
												"displayName": "Non-dismantlable",
												"children": [],
												"score": 139,
												"description": "4 seater non-dismantlable wooden top dining table",
												"identifier": 140,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 25
											}
										],
										"score": 138
									},
									{
										"name": "metalTop",
										"qualifiedName": "furniture.tables.diningTable.4Seater.metalTop",
										"displayName": "Metal top",
										"children": [
											{
												"name": "foldable",
												"qualifiedName": "furniture.tables.diningTable.4Seater.metalTop.foldable",
												"displayName": "Foldable",
												"children": [],
												"score": 140,
												"description": "4 seater foldable metal top dining table",
												"identifier": 141,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 20
											},
											{
												"name": "nonhyphenfoldable",
												"qualifiedName": "furniture.tables.diningTable.4Seater.metalTop.nonhyphenfoldable",
												"displayName": "Non-foldable",
												"children": [],
												"score": 141,
												"description": "4 seater non-foldable metal top dining table",
												"identifier": 142,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 25
											}
										],
										"score": 140
									},
									{
										"name": "glassTop",
										"qualifiedName": "furniture.tables.diningTable.4Seater.glassTop",
										"displayName": "Glass top",
										"children": [],
										"score": 142,
										"description": "4 seater glass top dining table",
										"identifier": 143,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 25
									}
								],
								"score": 138
							},
							{
								"name": "5Seater",
								"qualifiedName": "furniture.tables.diningTable.5Seater",
								"displayName": "5 seater",
								"children": [
									{
										"name": "woodenTop",
										"qualifiedName": "furniture.tables.diningTable.5Seater.woodenTop",
										"displayName": "Wooden top",
										"children": [
											{
												"name": "dismantlable",
												"qualifiedName": "furniture.tables.diningTable.5Seater.woodenTop.dismantlable",
												"displayName": "Dismantlable",
												"children": [],
												"score": 143,
												"description": "5 seater dismantlable wooden top dining table",
												"identifier": 144,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 30
											},
											{
												"name": "nonhyphendismantlable",
												"qualifiedName": "furniture.tables.diningTable.5Seater.woodenTop.nonhyphendismantlable",
												"displayName": "Non-dismantlable",
												"children": [],
												"score": 144,
												"description": "5 seater non-dismantlable wooden top dining table",
												"identifier": 145,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 34
											}
										],
										"score": 143
									},
									{
										"name": "metalTop",
										"qualifiedName": "furniture.tables.diningTable.5Seater.metalTop",
										"displayName": "Metal top",
										"children": [
											{
												"name": "foldable",
												"qualifiedName": "furniture.tables.diningTable.5Seater.metalTop.foldable",
												"displayName": "Foldable",
												"children": [],
												"score": 145,
												"description": "5 seater foldable metal top dining table",
												"identifier": 146,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 30
											},
											{
												"name": "nonhyphenfoldable",
												"qualifiedName": "furniture.tables.diningTable.5Seater.metalTop.nonhyphenfoldable",
												"displayName": "Non-foldable",
												"children": [],
												"score": 146,
												"description": "5 seater non-foldable metal top dining table",
												"identifier": 147,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 34
											}
										],
										"score": 145
									},
									{
										"name": "glassTop",
										"qualifiedName": "furniture.tables.diningTable.5Seater.glassTop",
										"displayName": "Glass top",
										"children": [],
										"score": 147,
										"description": "5 seater glass top dining table",
										"identifier": 148,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 34
									}
								],
								"score": 143
							},
							{
								"name": "6Seater",
								"qualifiedName": "furniture.tables.diningTable.6Seater",
								"displayName": "6 seater",
								"children": [
									{
										"name": "woodenTop",
										"qualifiedName": "furniture.tables.diningTable.6Seater.woodenTop",
										"displayName": "Wooden top",
										"children": [
											{
												"name": "dismantlable",
												"qualifiedName": "furniture.tables.diningTable.6Seater.woodenTop.dismantlable",
												"displayName": "Dismantlable",
												"children": [],
												"score": 148,
												"description": "6 seater dismantlable wooden top dining table",
												"identifier": 149,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "nonhyphendismantlable",
												"qualifiedName": "furniture.tables.diningTable.6Seater.woodenTop.nonhyphendismantlable",
												"displayName": "Non-dismantlable",
												"children": [],
												"score": 149,
												"description": "6 seater non-dismantlable wooden top dining table",
												"identifier": 150,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 40
											}
										],
										"score": 148
									},
									{
										"name": "metalTop",
										"qualifiedName": "furniture.tables.diningTable.6Seater.metalTop",
										"displayName": "Metal top",
										"children": [
											{
												"name": "foldable",
												"qualifiedName": "furniture.tables.diningTable.6Seater.metalTop.foldable",
												"displayName": "Foldable",
												"children": [],
												"score": 150,
												"description": "6 seater foldable metal top dining table",
												"identifier": 151,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "nonhyphenfoldable",
												"qualifiedName": "furniture.tables.diningTable.6Seater.metalTop.nonhyphenfoldable",
												"displayName": "Non-foldable",
												"children": [],
												"score": 151,
												"description": "6 seater non-foldable metal top dining table",
												"identifier": 152,
												"item_id": 38,
												"version": "2",
												"cubic_feet": 40
											}
										],
										"score": 150
									},
									{
										"name": "glassTop",
										"qualifiedName": "furniture.tables.diningTable.6Seater.glassTop",
										"displayName": "Glass top",
										"children": [],
										"score": 152,
										"description": "6 seater glass top dining table",
										"identifier": 153,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 40
									}
								],
								"score": 148
							},
							{
								"name": "7OrMoreSeater",
								"qualifiedName": "furniture.tables.diningTable.7OrMoreSeater",
								"displayName": "7or more seater",
								"children": [
									{
										"name": "woodenTop",
										"qualifiedName": "furniture.tables.diningTable.7OrMoreSeater.woodenTop",
										"displayName": "Wooden top",
										"children": [],
										"score": 153,
										"description": "7+ seater wooden top dining table",
										"identifier": 154,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 48
									},
									{
										"name": "metalTop",
										"qualifiedName": "furniture.tables.diningTable.7OrMoreSeater.metalTop",
										"displayName": "Metal top",
										"children": [],
										"score": 154,
										"description": "7+ seater metal top dining table",
										"identifier": 155,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 48
									},
									{
										"name": "glassTop",
										"qualifiedName": "furniture.tables.diningTable.7OrMoreSeater.glassTop",
										"displayName": "Glass top",
										"children": [],
										"score": 155,
										"description": "7+ seater glass top dining table",
										"identifier": 156,
										"item_id": 38,
										"version": "2",
										"cubic_feet": 60
									}
								],
								"score": 153
							}
						],
						"score": 128
					},
					{
						"name": "sideTable",
						"qualifiedName": "furniture.tables.sideTable",
						"displayName": "Side table",
						"children": [
							{
								"name": "glassTop",
								"qualifiedName": "furniture.tables.sideTable.glassTop",
								"displayName": "Glass top",
								"children": [],
								"score": 156,
								"description": "Glass-top side table",
								"identifier": 157,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "woodenTop",
								"qualifiedName": "furniture.tables.sideTable.woodenTop",
								"displayName": "Wooden top",
								"children": [],
								"score": 157,
								"description": "Wooden-top side table",
								"identifier": 158,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 7
							}
						],
						"score": 156
					},
					{
						"name": "plasticTable",
						"qualifiedName": "furniture.tables.plasticTable",
						"displayName": "Plastic table",
						"children": [],
						"score": 158,
						"description": "Plastic table",
						"identifier": 159,
						"item_id": 38,
						"version": "2",
						"cubic_feet": 15
					},
					{
						"name": "computerOfficeTable",
						"qualifiedName": "furniture.tables.computerOfficeTable",
						"displayName": "Computer / office table",
						"children": [
							{
								"name": "withStorage",
								"qualifiedName": "furniture.tables.computerOfficeTable.withStorage",
								"displayName": "With storage",
								"children": [],
								"score": 159,
								"description": "Computer / office table With storage",
								"identifier": 160,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 30
							},
							{
								"name": "withoutStorage",
								"qualifiedName": "furniture.tables.computerOfficeTable.withoutStorage",
								"displayName": "Without storage",
								"children": [],
								"score": 160,
								"description": "Computer / office table Without storage",
								"identifier": 161,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 25
							}
						],
						"score": 159
					},
					{
						"name": "dressingTable",
						"qualifiedName": "furniture.tables.dressingTable",
						"displayName": "Dressing table",
						"children": [
							{
								"name": "dismantlable",
								"qualifiedName": "furniture.tables.dressingTable.dismantlable",
								"displayName": "Dismantlable",
								"children": [],
								"score": 161,
								"description": "Dismantlable dressing table",
								"identifier": 162,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 30
							},
							{
								"name": "nonhyphendismantlable",
								"qualifiedName": "furniture.tables.dressingTable.nonhyphendismantlable",
								"displayName": "Non-dismantlable",
								"children": [],
								"score": 162,
								"description": "Non-dismantlable dressing table",
								"identifier": 163,
								"item_id": 38,
								"version": "2",
								"cubic_feet": 40
							}
						],
						"score": 161
					},
					{
						"name": "ironBoard",
						"qualifiedName": "furniture.tables.ironBoard",
						"displayName": "Iron board",
						"children": [],
						"score": 163,
						"description": "Iron board",
						"identifier": 164,
						"item_id": 38,
						"version": "2",
						"cubic_feet": 5
					}
				],
				"score": 126,
				"item_id": 38
			},
			{
				"name": "chairs",
				"qualifiedName": "furniture.chairs",
				"displayName": "Chairs",
				"children": [
					{
						"name": "officeComputer",
						"qualifiedName": "furniture.chairs.officeComputer",
						"displayName": "Office/computer",
						"children": [],
						"score": 164,
						"description": "Office chair",
						"identifier": 165,
						"item_id": 37,
						"version": "2",
						"cubic_feet": 8
					},
					{
						"name": "kid",
						"qualifiedName": "furniture.chairs.kid",
						"displayName": "Kid",
						"children": [],
						"score": 165,
						"description": "Kids chair",
						"identifier": 166,
						"item_id": 37,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "dining",
						"qualifiedName": "furniture.chairs.dining",
						"displayName": "Dining",
						"children": [],
						"score": 166,
						"description": "Dining chair",
						"identifier": 167,
						"item_id": 37,
						"version": "2",
						"cubic_feet": 8
					},
					{
						"name": "rocking",
						"qualifiedName": "furniture.chairs.rocking",
						"displayName": "Rocking",
						"children": [
							{
								"name": "wooden",
								"qualifiedName": "furniture.chairs.rocking.wooden",
								"displayName": "Wooden",
								"children": [],
								"score": 167,
								"description": "Wooden rocking chair",
								"identifier": 168,
								"item_id": 37,
								"version": "2",
								"cubic_feet": 15
							},
							{
								"name": "steel",
								"qualifiedName": "furniture.chairs.rocking.steel",
								"displayName": "Steel",
								"children": [],
								"score": 168,
								"description": "Steel rocking chair",
								"identifier": 169,
								"item_id": 37,
								"version": "2",
								"cubic_feet": 15
							}
						],
						"score": 167
					},
					{
						"name": "plastic",
						"qualifiedName": "furniture.chairs.plastic",
						"displayName": "Plastic",
						"children": [],
						"score": 169,
						"description": "plastic chair",
						"identifier": 170,
						"item_id": 37,
						"version": "2",
						"cubic_feet": 8
					},
					{
						"name": "executive",
						"qualifiedName": "furniture.chairs.executive",
						"displayName": "Executive",
						"children": [
							{
								"name": "rolling",
								"qualifiedName": "furniture.chairs.executive.rolling",
								"displayName": "Rolling",
								"children": [],
								"score": 170,
								"description": "Executive rolling chair",
								"identifier": 171,
								"item_id": 37,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "nonhyphenrolling",
								"qualifiedName": "furniture.chairs.executive.nonhyphenrolling",
								"displayName": "Non-rolling",
								"children": [],
								"score": 171,
								"description": "Executive non-rolling chair",
								"identifier": 172,
								"item_id": 37,
								"version": "2",
								"cubic_feet": 10
							}
						],
						"score": 170
					}
				],
				"score": 164,
				"item_id": 37
			},
			{
				"name": "cots",
				"qualifiedName": "furniture.cots",
				"displayName": "Cots",
				"children": [
					{
						"name": "kingSize",
						"qualifiedName": "furniture.cots.kingSize",
						"displayName": "King size",
						"children": [
							{
								"name": "dismantlable",
								"qualifiedName": "furniture.cots.kingSize.dismantlable",
								"displayName": "Dismantlable",
								"children": [
									{
										"name": "withStorage",
										"qualifiedName": "furniture.cots.kingSize.dismantlable.withStorage",
										"displayName": "With storage",
										"children": [],
										"score": 172,
										"description": "King size dismantlable cot with storage",
										"identifier": 173,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 71
									},
									{
										"name": "withoutStorage",
										"qualifiedName": "furniture.cots.kingSize.dismantlable.withoutStorage",
										"displayName": "Without storage",
										"children": [],
										"score": 173,
										"description": "King size dismantlable cot without storage",
										"identifier": 174,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 71
									}
								],
								"score": 172
							},
							{
								"name": "foldable",
								"qualifiedName": "furniture.cots.kingSize.foldable",
								"displayName": "Foldable",
								"children": [],
								"score": 174,
								"description": "King size foldable cot",
								"identifier": 175,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 71
							},
							{
								"name": "neither",
								"qualifiedName": "furniture.cots.kingSize.neither",
								"displayName": "Neither",
								"children": [],
								"score": 175,
								"description": "King size cot",
								"identifier": 176,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 71
							}
						],
						"score": 172
					},
					{
						"name": "queenSize",
						"qualifiedName": "furniture.cots.queenSize",
						"displayName": "Queen size",
						"children": [
							{
								"name": "dismantlable",
								"qualifiedName": "furniture.cots.queenSize.dismantlable",
								"displayName": "Dismantlable",
								"children": [
									{
										"name": "withStorage",
										"qualifiedName": "furniture.cots.queenSize.dismantlable.withStorage",
										"displayName": "With storage",
										"children": [],
										"score": 176,
										"description": "Queen size dismantlable cot with storage",
										"identifier": 177,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 66
									},
									{
										"name": "withoutStorage",
										"qualifiedName": "furniture.cots.queenSize.dismantlable.withoutStorage",
										"displayName": "Without storage",
										"children": [],
										"score": 177,
										"description": "Queen size dismantlable cot without storage",
										"identifier": 178,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 66
									}
								],
								"score": 176
							},
							{
								"name": "foldable",
								"qualifiedName": "furniture.cots.queenSize.foldable",
								"displayName": "Foldable",
								"children": [],
								"score": 178,
								"description": "Queen size foldable cot",
								"identifier": 179,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 66
							},
							{
								"name": "neither",
								"qualifiedName": "furniture.cots.queenSize.neither",
								"displayName": "Neither",
								"children": [],
								"score": 179,
								"description": "Queen size cot",
								"identifier": 180,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 66
							}
						],
						"score": 176
					},
					{
						"name": "doubleCot",
						"qualifiedName": "furniture.cots.doubleCot",
						"displayName": "Double cot",
						"children": [
							{
								"name": "dismantlable",
								"qualifiedName": "furniture.cots.doubleCot.dismantlable",
								"displayName": "Dismantlable",
								"children": [
									{
										"name": "withStorage",
										"qualifiedName": "furniture.cots.doubleCot.dismantlable.withStorage",
										"displayName": "With storage",
										"children": [],
										"score": 180,
										"description": "Double dismantlable cot with storage",
										"identifier": 181,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 55
									},
									{
										"name": "withoutStorage",
										"qualifiedName": "furniture.cots.doubleCot.dismantlable.withoutStorage",
										"displayName": "Without storage",
										"children": [],
										"score": 181,
										"description": "Double dismantlable cot without storage",
										"identifier": 182,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 55
									}
								],
								"score": 180
							},
							{
								"name": "foldable",
								"qualifiedName": "furniture.cots.doubleCot.foldable",
								"displayName": "Foldable",
								"children": [],
								"score": 182,
								"description": "Double foldable cot",
								"identifier": 183,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 55
							},
							{
								"name": "neither",
								"qualifiedName": "furniture.cots.doubleCot.neither",
								"displayName": "Neither",
								"children": [],
								"score": 183,
								"description": "Double cot",
								"identifier": 184,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 55
							}
						],
						"score": 180
					},
					{
						"name": "singleCot",
						"qualifiedName": "furniture.cots.singleCot",
						"displayName": "Single cot",
						"children": [
							{
								"name": "dismantlable",
								"qualifiedName": "furniture.cots.singleCot.dismantlable",
								"displayName": "Dismantlable",
								"children": [
									{
										"name": "withStorage",
										"qualifiedName": "furniture.cots.singleCot.dismantlable.withStorage",
										"displayName": "With storage",
										"children": [],
										"score": 184,
										"description": "Single dismantlable cot with storage",
										"identifier": 185,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 36
									},
									{
										"name": "withoutStorage",
										"qualifiedName": "furniture.cots.singleCot.dismantlable.withoutStorage",
										"displayName": "Without storage",
										"children": [],
										"score": 185,
										"description": "Single dismantlable cot without storage",
										"identifier": 186,
										"item_id": 36,
										"version": "2",
										"cubic_feet": 36
									}
								],
								"score": 184
							},
							{
								"name": "foldable",
								"qualifiedName": "furniture.cots.singleCot.foldable",
								"displayName": "Foldable",
								"children": [],
								"score": 186,
								"description": "Single foldable cot",
								"identifier": 187,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 36
							},
							{
								"name": "neither",
								"qualifiedName": "furniture.cots.singleCot.neither",
								"displayName": "Neither",
								"children": [],
								"score": 187,
								"description": "Single cot",
								"identifier": 188,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 36
							}
						],
						"score": 184
					},
					{
						"name": "bunkBed",
						"qualifiedName": "furniture.cots.bunkBed",
						"displayName": "Bunk bed",
						"children": [],
						"score": 188,
						"description": "Bunk bed",
						"identifier": 189,
						"item_id": 36,
						"version": "2",
						"cubic_feet": 72
					},
					{
						"name": "diwan",
						"qualifiedName": "furniture.cots.diwan",
						"displayName": "Diwan",
						"children": [
							{
								"name": "withStorage",
								"qualifiedName": "furniture.cots.diwan.withStorage",
								"displayName": "With storage",
								"children": [],
								"score": 189,
								"description": "Diwan with storage",
								"identifier": 190,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 35
							},
							{
								"name": "withoutStorage",
								"qualifiedName": "furniture.cots.diwan.withoutStorage",
								"displayName": "Without storage",
								"children": [],
								"score": 190,
								"description": "Diwan without storage",
								"identifier": 191,
								"item_id": 36,
								"version": "2",
								"cubic_feet": 35
							}
						],
						"score": 189
					}
				],
				"score": 172,
				"item_id": 36
			},
			{
				"name": "mattress",
				"qualifiedName": "furniture.mattress",
				"displayName": "Mattress",
				"children": [
					{
						"name": "double",
						"qualifiedName": "furniture.mattress.double",
						"displayName": "Double",
						"children": [
							{
								"name": "lt4InchThickness",
								"qualifiedName": "furniture.mattress.double.lt4InchThickness",
								"displayName": "< 4 inch thickness",
								"children": [],
								"score": 191,
								"description": "Thin double mattress",
								"identifier": 192,
								"item_id": 35,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "4To8InchThickness",
								"qualifiedName": "furniture.mattress.double.4To8InchThickness",
								"displayName": "4 to 8 inch thickness",
								"children": [],
								"score": 192,
								"description": "Medium double mattress",
								"identifier": 193,
								"item_id": 35,
								"version": "2",
								"cubic_feet": 20
							},
							{
								"name": "gt8InchThickness",
								"qualifiedName": "furniture.mattress.double.gt8InchThickness",
								"displayName": "> 8 inch thickness",
								"children": [],
								"score": 193,
								"description": "Thick double mattress",
								"identifier": 194,
								"item_id": 35,
								"version": "2",
								"cubic_feet": 30
							}
						],
						"score": 191
					},
					{
						"name": "single",
						"qualifiedName": "furniture.mattress.single",
						"displayName": "Single",
						"children": [
							{
								"name": "lt4InchThickness",
								"qualifiedName": "furniture.mattress.single.lt4InchThickness",
								"displayName": "< 4 inch thickness",
								"children": [],
								"score": 194,
								"description": "Thin single mattress",
								"identifier": 195,
								"item_id": 35,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "4To8InchThickness",
								"qualifiedName": "furniture.mattress.single.4To8InchThickness",
								"displayName": "4 to 8 inch thickness",
								"children": [],
								"score": 195,
								"description": "Medium single mattress",
								"identifier": 196,
								"item_id": 35,
								"version": "2",
								"cubic_feet": 15
							},
							{
								"name": "gt8InchThickness",
								"qualifiedName": "furniture.mattress.single.gt8InchThickness",
								"displayName": "> 8 inch thickness",
								"children": [],
								"score": 196,
								"description": "Thick single mattress",
								"identifier": 197,
								"item_id": 35,
								"version": "2",
								"cubic_feet": 20
							}
						],
						"score": 194
					}
				],
				"score": 191,
				"item_id": 35
			},
			{
				"name": "cupboards",
				"qualifiedName": "furniture.cupboards",
				"displayName": "Cupboards",
				"children": [
					{
						"name": "woodenWardrobe",
						"qualifiedName": "furniture.cupboards.woodenWardrobe",
						"displayName": "Wooden wardrobe",
						"children": [
							{
								"name": "heightLt2Ft",
								"qualifiedName": "furniture.cupboards.woodenWardrobe.heightLt2Ft",
								"displayName": "Height < 2 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightLt2Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 197,
										"description": "Small wooden wardrobe",
										"identifier": 198,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 8
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightLt2Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 198,
										"description": "Small wooden wardrobe",
										"identifier": 199,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 17
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightLt2Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 199,
										"description": "Small wooden wardrobe",
										"identifier": 200,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 22
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightLt2Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 200,
										"description": "Small wooden wardrobe",
										"identifier": 201,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 30
									}
								],
								"score": 197
							},
							{
								"name": "height2Hyphen4Ft",
								"qualifiedName": "furniture.cupboards.woodenWardrobe.height2Hyphen4Ft",
								"displayName": "Height 2 - 4 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height2Hyphen4Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 201,
										"description": "Small wooden wardrobe",
										"identifier": 202,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 15
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height2Hyphen4Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 202,
										"description": "Small wooden wardrobe",
										"identifier": 203,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 34
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height2Hyphen4Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 203,
										"description": "Medium wooden wardrobe",
										"identifier": 204,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 40
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height2Hyphen4Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 204,
										"description": "Large wooden wardrobe",
										"identifier": 205,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 60
									}
								],
								"score": 201
							},
							{
								"name": "height4Hyphen6Ft",
								"qualifiedName": "furniture.cupboards.woodenWardrobe.height4Hyphen6Ft",
								"displayName": "Height 4 - 6 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height4Hyphen6Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 205,
										"description": "Small wooden wardrobe",
										"identifier": 206,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 22
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height4Hyphen6Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 206,
										"description": "Medium wooden wardrobe",
										"identifier": 207,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 40
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height4Hyphen6Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 207,
										"description": "Large wooden wardrobe",
										"identifier": 208,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 68
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.height4Hyphen6Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 208,
										"description": "Large wooden wardrobe",
										"identifier": 209,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 90
									}
								],
								"score": 205
							},
							{
								"name": "heightGt6Ft",
								"qualifiedName": "furniture.cupboards.woodenWardrobe.heightGt6Ft",
								"displayName": "Height > 6 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightGt6Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 209,
										"description": "Medium wooden wardrobe",
										"identifier": 210,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 30
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightGt6Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 210,
										"description": "Large wooden wardrobe",
										"identifier": 211,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 60
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightGt6Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 211,
										"description": "Large wooden wardrobe",
										"identifier": 212,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 90
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.woodenWardrobe.heightGt6Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 212,
										"description": "Large wooden wardrobe",
										"identifier": 213,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 120
									}
								],
								"score": 209
							}
						],
						"score": 197
					},
					{
						"name": "steelAlmirah",
						"qualifiedName": "furniture.cupboards.steelAlmirah",
						"displayName": "Steel almirah",
						"children": [
							{
								"name": "heightLte5Ft",
								"qualifiedName": "furniture.cupboards.steelAlmirah.heightLte5Ft",
								"displayName": "Height <= 5 ft",
								"children": [],
								"score": 213,
								"description": "Small steel almirah",
								"identifier": 214,
								"item_id": 34,
								"version": "2",
								"cubic_feet": 40
							},
							{
								"name": "heightGt5Ft",
								"qualifiedName": "furniture.cupboards.steelAlmirah.heightGt5Ft",
								"displayName": "Height > 5 ft",
								"children": [],
								"score": 214,
								"description": "Large steel almirah",
								"identifier": 215,
								"item_id": 34,
								"version": "2",
								"cubic_feet": 60
							}
						],
						"score": 213
					},
					{
						"name": "plasticCupboard",
						"qualifiedName": "furniture.cupboards.plasticCupboard",
						"displayName": "Plastic cupboard",
						"children": [],
						"score": 215,
						"description": "Plastic cupboard",
						"identifier": 216,
						"item_id": 34,
						"version": "2",
						"cubic_feet": 10
					},
					{
						"name": "showcase",
						"qualifiedName": "furniture.cupboards.showcase",
						"displayName": "Showcase",
						"children": [
							{
								"name": "withGlassFitments",
								"qualifiedName": "furniture.cupboards.showcase.withGlassFitments",
								"displayName": "With glass fitments",
								"children": [
									{
										"name": "heightLt2Ft",
										"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightLt2Ft",
										"displayName": "Height < 2 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightLt2Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 216,
												"description": "Small showcase with glass fitments",
												"identifier": 217,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 6
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightLt2Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 217,
												"description": "Small showcase with glass fitments",
												"identifier": 218,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightLt2Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 218,
												"description": "Small showcase with glass fitments",
												"identifier": 219,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightLt2Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 219,
												"description": "Small showcase with glass fitments",
												"identifier": 220,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											}
										],
										"score": 216
									},
									{
										"name": "height2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height2Hyphen4Ft",
										"displayName": "Height 2 - 4 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height2Hyphen4Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 220,
												"description": "Small showcase with glass fitments",
												"identifier": 221,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height2Hyphen4Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 221,
												"description": "Small showcase with glass fitments",
												"identifier": 222,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height2Hyphen4Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 222,
												"description": "Medium showcase with glass fitments",
												"identifier": 223,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height2Hyphen4Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 223,
												"description": "Large showcase with glass fitments",
												"identifier": 224,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 50
											}
										],
										"score": 220
									},
									{
										"name": "height4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height4Hyphen6Ft",
										"displayName": "Height 4 - 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height4Hyphen6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 224,
												"description": "Small showcase with glass fitments",
												"identifier": 225,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height4Hyphen6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 225,
												"description": "Medium showcase with glass fitments",
												"identifier": 226,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height4Hyphen6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 226,
												"description": "Large showcase with glass fitments",
												"identifier": 227,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 54
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.height4Hyphen6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 227,
												"description": "Large showcase with glass fitments",
												"identifier": 228,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 224
									},
									{
										"name": "heightGt6Ft",
										"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightGt6Ft",
										"displayName": "Height > 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightGt6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 228,
												"description": "Medium showcase with glass fitments",
												"identifier": 229,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightGt6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 229,
												"description": "Large showcase with glass fitments",
												"identifier": 230,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 48
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightGt6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 230,
												"description": "Large showcase with glass fitments",
												"identifier": 231,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withGlassFitments.heightGt6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 231,
												"description": "Large showcase with glass fitments",
												"identifier": 232,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 228
									}
								],
								"score": 216
							},
							{
								"name": "withoutGlassFitments",
								"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments",
								"displayName": "Without glass fitments",
								"children": [
									{
										"name": "heightLt2Ft",
										"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightLt2Ft",
										"displayName": "Height < 2 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightLt2Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 232,
												"description": "Small showcase without glass fitments",
												"identifier": 233,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 6
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightLt2Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 233,
												"description": "Small showcase without glass fitments",
												"identifier": 234,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightLt2Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 234,
												"description": "Small showcase without glass fitments",
												"identifier": 235,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightLt2Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 235,
												"description": "Small showcase without glass fitments",
												"identifier": 236,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											}
										],
										"score": 232
									},
									{
										"name": "height2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height2Hyphen4Ft",
										"displayName": "Height 2 - 4 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height2Hyphen4Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 236,
												"description": "Small showcase without glass fitments",
												"identifier": 237,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height2Hyphen4Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 237,
												"description": "Small showcase without glass fitments",
												"identifier": 238,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height2Hyphen4Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 238,
												"description": "Medium showcase without glass fitments",
												"identifier": 239,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height2Hyphen4Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 239,
												"description": "Large showcase without glass fitments",
												"identifier": 240,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 50
											}
										],
										"score": 236
									},
									{
										"name": "height4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height4Hyphen6Ft",
										"displayName": "Height 4 - 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height4Hyphen6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 240,
												"description": "Small showcase without glass fitments",
												"identifier": 241,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height4Hyphen6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 241,
												"description": "Medium showcase without glass fitments",
												"identifier": 242,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height4Hyphen6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 242,
												"description": "Large showcase without glass fitments",
												"identifier": 243,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 54
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.height4Hyphen6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 243,
												"description": "Large showcase without glass fitments",
												"identifier": 244,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 240
									},
									{
										"name": "heightGt6Ft",
										"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightGt6Ft",
										"displayName": "Height > 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightGt6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 244,
												"description": "Medium showcase without glass fitments",
												"identifier": 245,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightGt6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 245,
												"description": "Large showcase without glass fitments",
												"identifier": 246,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 48
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightGt6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 246,
												"description": "Large showcase without glass fitments",
												"identifier": 247,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.showcase.withoutGlassFitments.heightGt6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 247,
												"description": "Large showcase without glass fitments",
												"identifier": 248,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 244
									}
								],
								"score": 232
							}
						],
						"score": 216
					},
					{
						"name": "shoeRack",
						"qualifiedName": "furniture.cupboards.shoeRack",
						"displayName": "Shoe rack",
						"children": [
							{
								"name": "heightLt2Ft",
								"qualifiedName": "furniture.cupboards.shoeRack.heightLt2Ft",
								"displayName": "Height < 2 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightLt2Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 248,
										"description": "Small shoe rack",
										"identifier": 249,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 6
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightLt2Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 249,
										"description": "Small shoe rack",
										"identifier": 250,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 12
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightLt2Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 250,
										"description": "Small shoe rack",
										"identifier": 251,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 18
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightLt2Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 251,
										"description": "Small shoe rack",
										"identifier": 252,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 25
									}
								],
								"score": 248
							},
							{
								"name": "height2Hyphen4Ft",
								"qualifiedName": "furniture.cupboards.shoeRack.height2Hyphen4Ft",
								"displayName": "Height 2 - 4 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height2Hyphen4Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 252,
										"description": "Small shoe rack",
										"identifier": 253,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 12
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height2Hyphen4Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 253,
										"description": "Small shoe rack",
										"identifier": 254,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 25
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height2Hyphen4Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 254,
										"description": "Medium shoe rack",
										"identifier": 255,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 36
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height2Hyphen4Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 255,
										"description": "Large shoe rack",
										"identifier": 256,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 50
									}
								],
								"score": 252
							},
							{
								"name": "height4Hyphen6Ft",
								"qualifiedName": "furniture.cupboards.shoeRack.height4Hyphen6Ft",
								"displayName": "Height 4 - 6 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height4Hyphen6Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 256,
										"description": "Small shoe rack",
										"identifier": 257,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 18
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height4Hyphen6Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 257,
										"description": "Medium shoe rack",
										"identifier": 258,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 36
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height4Hyphen6Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 258,
										"description": "Large shoe rack",
										"identifier": 259,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 54
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.height4Hyphen6Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 259,
										"description": "Large shoe rack",
										"identifier": 260,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 75
									}
								],
								"score": 256
							},
							{
								"name": "heightGt6Ft",
								"qualifiedName": "furniture.cupboards.shoeRack.heightGt6Ft",
								"displayName": "Height > 6 ft",
								"children": [
									{
										"name": "widthLt2Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightGt6Ft.widthLt2Ft",
										"displayName": "Width < 2 ft",
										"children": [],
										"score": 260,
										"description": "Medium shoe rack",
										"identifier": 261,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 25
									},
									{
										"name": "width2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightGt6Ft.width2Hyphen4Ft",
										"displayName": "Width 2 - 4 ft",
										"children": [],
										"score": 261,
										"description": "Large shoe rack",
										"identifier": 262,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 48
									},
									{
										"name": "width4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightGt6Ft.width4Hyphen6Ft",
										"displayName": "Width 4 - 6 ft",
										"children": [],
										"score": 262,
										"description": "Large shoe rack",
										"identifier": 263,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 75
									},
									{
										"name": "widthGt6Ft",
										"qualifiedName": "furniture.cupboards.shoeRack.heightGt6Ft.widthGt6Ft",
										"displayName": "Width > 6 ft",
										"children": [],
										"score": 263,
										"description": "Large shoe rack",
										"identifier": 264,
										"item_id": 34,
										"version": "2",
										"cubic_feet": 100
									}
								],
								"score": 260
							}
						],
						"score": 248
					},
					{
						"name": "tvCabinet",
						"qualifiedName": "furniture.cupboards.tvCabinet",
						"displayName": "Tv cabinet",
						"children": [
							{
								"name": "withGlassFitments",
								"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments",
								"displayName": "With glass fitments",
								"children": [
									{
										"name": "heightLt2Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightLt2Ft",
										"displayName": "Height < 2 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightLt2Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 264,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 265,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 8
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightLt2Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 265,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 266,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 17
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightLt2Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 266,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 267,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 22
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightLt2Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 267,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 268,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 30
											}
										],
										"score": 264
									},
									{
										"name": "height2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height2Hyphen4Ft",
										"displayName": "Height 2 - 4 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height2Hyphen4Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 268,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 269,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 15
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height2Hyphen4Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 269,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 270,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 34
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height2Hyphen4Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 270,
												"description": "Medium TV cabinet with glass fitments",
												"identifier": 271,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 40
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height2Hyphen4Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 271,
												"description": "Large TV cabinet with glass fitments",
												"identifier": 272,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 60
											}
										],
										"score": 268
									},
									{
										"name": "height4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height4Hyphen6Ft",
										"displayName": "Height 4 - 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height4Hyphen6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 272,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 273,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 22
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height4Hyphen6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 273,
												"description": "Medium TV cabinet with glass fitments",
												"identifier": 274,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 40
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height4Hyphen6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 274,
												"description": "Large TV cabinet with glass fitments",
												"identifier": 275,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 68
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.height4Hyphen6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 275,
												"description": "Large TV cabinet with glass fitments",
												"identifier": 276,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 90
											}
										],
										"score": 272
									},
									{
										"name": "heightGt6Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightGt6Ft",
										"displayName": "Height > 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightGt6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 276,
												"description": "Medium TV cabinet with glass fitments",
												"identifier": 277,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 30
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightGt6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 277,
												"description": "Large TV cabinet with glass fitments",
												"identifier": 278,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 60
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightGt6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 278,
												"description": "Large TV cabinet with glass fitments",
												"identifier": 279,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 90
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withGlassFitments.heightGt6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 279,
												"description": "Large TV cabinet with glass fitments",
												"identifier": 280,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 276
									}
								],
								"score": 264
							},
							{
								"name": "withoutGlassFitments",
								"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments",
								"displayName": "Without glass fitments",
								"children": [
									{
										"name": "heightLt2Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightLt2Ft",
										"displayName": "Height < 2 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightLt2Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 280,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 281,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 8
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightLt2Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 281,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 282,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 17
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightLt2Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 282,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 283,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 22
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightLt2Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 283,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 284,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 30
											}
										],
										"score": 280
									},
									{
										"name": "height2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height2Hyphen4Ft",
										"displayName": "Height 2 - 4 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height2Hyphen4Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 284,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 285,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 15
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height2Hyphen4Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 285,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 286,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 34
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height2Hyphen4Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 286,
												"description": "Medium TV cabinet without glass fitments",
												"identifier": 287,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 40
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height2Hyphen4Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 287,
												"description": "Large TV cabinet without glass fitments",
												"identifier": 288,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 60
											}
										],
										"score": 284
									},
									{
										"name": "height4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height4Hyphen6Ft",
										"displayName": "Height 4 - 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height4Hyphen6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 288,
												"description": "Small TV cabinet without glass fitments",
												"identifier": 289,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 22
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height4Hyphen6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 289,
												"description": "Medium TV cabinet without glass fitments",
												"identifier": 290,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 40
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height4Hyphen6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 290,
												"description": "Large TV cabinet without glass fitments",
												"identifier": 291,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 68
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.height4Hyphen6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 291,
												"description": "Large TV cabinet without glass fitments",
												"identifier": 292,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 90
											}
										],
										"score": 288
									},
									{
										"name": "heightGt6Ft",
										"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightGt6Ft",
										"displayName": "Height > 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightGt6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 292,
												"description": "Medium TV cabinet without glass fitments",
												"identifier": 293,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 30
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightGt6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 293,
												"description": "Large TV cabinet without glass fitments",
												"identifier": 294,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 60
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightGt6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 294,
												"description": "Large TV cabinet without glass fitments",
												"identifier": 295,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 90
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.tvCabinet.withoutGlassFitments.heightGt6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 295,
												"description": "Large TV cabinet without glass fitments",
												"identifier": 296,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 120
											}
										],
										"score": 292
									}
								],
								"score": 280
							}
						],
						"score": 264
					},
					{
						"name": "bookShelf",
						"qualifiedName": "furniture.cupboards.bookShelf",
						"displayName": "Book shelf",
						"children": [
							{
								"name": "withGlassFitments",
								"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments",
								"displayName": "With glass fitments",
								"children": [
									{
										"name": "heightLt2Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightLt2Ft",
										"displayName": "Height < 2 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightLt2Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 296,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 297,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 6
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightLt2Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 297,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 298,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightLt2Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 298,
												"description": "Small TV cabinet with glass fitments",
												"identifier": 299,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightLt2Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 299,
												"description": "Small book shelf with glass fitments",
												"identifier": 300,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											}
										],
										"score": 296
									},
									{
										"name": "height2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height2Hyphen4Ft",
										"displayName": "Height 2 - 4 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height2Hyphen4Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 300,
												"description": "Small book shelf with glass fitments",
												"identifier": 301,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height2Hyphen4Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 301,
												"description": "Small book shelf with glass fitments",
												"identifier": 302,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height2Hyphen4Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 302,
												"description": "Medium book shelf with glass fitments",
												"identifier": 303,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height2Hyphen4Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 303,
												"description": "Large book shelf with glass fitments",
												"identifier": 304,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 50
											}
										],
										"score": 300
									},
									{
										"name": "height4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height4Hyphen6Ft",
										"displayName": "Height 4 - 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height4Hyphen6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 304,
												"description": "Small book shelf with glass fitments",
												"identifier": 305,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height4Hyphen6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 305,
												"description": "Medium book shelf with glass fitments",
												"identifier": 306,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height4Hyphen6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 306,
												"description": "Large book shelf with glass fitments",
												"identifier": 307,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 54
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.height4Hyphen6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 307,
												"description": "Large book shelf with glass fitments",
												"identifier": 308,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 304
									},
									{
										"name": "heightGt6Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightGt6Ft",
										"displayName": "Height > 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightGt6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 308,
												"description": "Medium book shelf with glass fitments",
												"identifier": 309,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightGt6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 309,
												"description": "Large book shelf with glass fitments",
												"identifier": 310,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 48
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightGt6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 310,
												"description": "Large book shelf with glass fitments",
												"identifier": 311,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withGlassFitments.heightGt6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 311,
												"description": "Large book shelf with glass fitments",
												"identifier": 312,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 308
									}
								],
								"score": 296
							},
							{
								"name": "withoutGlassFitments",
								"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments",
								"displayName": "Without glass fitments",
								"children": [
									{
										"name": "heightLt2Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightLt2Ft",
										"displayName": "Height < 2 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightLt2Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 312,
												"description": "Small book shelf without glass fitments",
												"identifier": 313,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 6
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightLt2Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 313,
												"description": "Small book shelf without glass fitments",
												"identifier": 314,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightLt2Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 314,
												"description": "Small book shelf without glass fitments",
												"identifier": 315,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightLt2Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 315,
												"description": "Small book shelf without glass fitments",
												"identifier": 316,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											}
										],
										"score": 312
									},
									{
										"name": "height2Hyphen4Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height2Hyphen4Ft",
										"displayName": "Height 2 - 4 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height2Hyphen4Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 316,
												"description": "Small book shelf without glass fitments",
												"identifier": 317,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 12
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height2Hyphen4Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 317,
												"description": "Small book shelf without glass fitments",
												"identifier": 318,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height2Hyphen4Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 318,
												"description": "Medium book shelf without glass fitments",
												"identifier": 319,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height2Hyphen4Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 319,
												"description": "Large book shelf without glass fitments",
												"identifier": 320,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 50
											}
										],
										"score": 316
									},
									{
										"name": "height4Hyphen6Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height4Hyphen6Ft",
										"displayName": "Height 4 - 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height4Hyphen6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 320,
												"description": "Small book shelf without glass fitments",
												"identifier": 321,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 18
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height4Hyphen6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 321,
												"description": "Medium book shelf without glass fitments",
												"identifier": 322,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 36
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height4Hyphen6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 322,
												"description": "Large book shelf without glass fitments",
												"identifier": 323,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 54
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.height4Hyphen6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 323,
												"description": "Large book shelf without glass fitments",
												"identifier": 324,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											}
										],
										"score": 320
									},
									{
										"name": "heightGt6Ft",
										"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightGt6Ft",
										"displayName": "Height > 6 ft",
										"children": [
											{
												"name": "widthLt2Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightGt6Ft.widthLt2Ft",
												"displayName": "Width < 2 ft",
												"children": [],
												"score": 324,
												"description": "Medium book shelf without glass fitments",
												"identifier": 325,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 25
											},
											{
												"name": "width2Hyphen4Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightGt6Ft.width2Hyphen4Ft",
												"displayName": "Width 2 - 4 ft",
												"children": [],
												"score": 325,
												"description": "Large book shelf without glass fitments",
												"identifier": 326,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 48
											},
											{
												"name": "width4Hyphen6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightGt6Ft.width4Hyphen6Ft",
												"displayName": "Width 4 - 6 ft",
												"children": [],
												"score": 326,
												"description": "Large book shelf without glass fitments",
												"identifier": 327,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 75
											},
											{
												"name": "widthGt6Ft",
												"qualifiedName": "furniture.cupboards.bookShelf.withoutGlassFitments.heightGt6Ft.widthGt6Ft",
												"displayName": "Width > 6 ft",
												"children": [],
												"score": 327,
												"description": "Large book shelf without glass fitments",
												"identifier": 328,
												"item_id": 34,
												"version": "2",
												"cubic_feet": 100
											}
										],
										"score": 324
									}
								],
								"score": 312
							}
						],
						"score": 296
					}
				],
				"score": 197,
				"item_id": 34
			}
		]
	},
	{
		"name": "electronics",
		"qualifiedName": "electronics",
		"displayName": "Electronics",
		"children": [
			{
				"name": "tVs",
				"qualifiedName": "electronics.tVs",
				"displayName": "TVs",
				"children": [
					{
						"name": "led",
						"qualifiedName": "electronics.tVs.led",
						"displayName": "LED",
						"children": [
							{
								"name": "lt24Inch",
								"qualifiedName": "electronics.tVs.led.lt24Inch",
								"displayName": "< 24 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.lt24Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 328,
										"description": "< 24 inch wall mounted LED TV",
										"identifier": 329,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 7
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.lt24Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 329,
										"description": "< 24 inch non-wall mounted LED TV",
										"identifier": 330,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 7
									}
								],
								"score": 328
							},
							{
								"name": "24Hyphen31Inch",
								"qualifiedName": "electronics.tVs.led.24Hyphen31Inch",
								"displayName": "24-31 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.24Hyphen31Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 330,
										"description": "24-31 inch wall mounted LED TV",
										"identifier": 331,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.24Hyphen31Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 331,
										"description": "24-31 inch non-wall mounted LED TV",
										"identifier": 332,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									}
								],
								"score": 330
							},
							{
								"name": "32Inch",
								"qualifiedName": "electronics.tVs.led.32Inch",
								"displayName": "32 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.32Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 332,
										"description": "32 inch wall mounted LED TV",
										"identifier": 333,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.32Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 333,
										"description": "32 inch non-wall mounted LED TV",
										"identifier": 334,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									}
								],
								"score": 332
							},
							{
								"name": "33Hyphen39Inch",
								"qualifiedName": "electronics.tVs.led.33Hyphen39Inch",
								"displayName": "33-39 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.33Hyphen39Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 334,
										"description": "33-39 inch wall mounted LED TV",
										"identifier": 335,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.33Hyphen39Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 335,
										"description": "33-39 inch non-wall mounted LED TV",
										"identifier": 336,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									}
								],
								"score": 334
							},
							{
								"name": "40Hyphen42Inch",
								"qualifiedName": "electronics.tVs.led.40Hyphen42Inch",
								"displayName": "40-42 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.40Hyphen42Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 336,
										"description": "40-42 inch wall mounted LED TV",
										"identifier": 337,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.40Hyphen42Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 337,
										"description": "40-42 inch non-wall mounted LED TV",
										"identifier": 338,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									}
								],
								"score": 336
							},
							{
								"name": "43Hyphen54Inch",
								"qualifiedName": "electronics.tVs.led.43Hyphen54Inch",
								"displayName": "43-54 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.43Hyphen54Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 338,
										"description": "43-54 inch wall mounted LED TV",
										"identifier": 339,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 11
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.43Hyphen54Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 339,
										"description": "43-54 inch non-wall mounted LED TV",
										"identifier": 340,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 11
									}
								],
								"score": 338
							},
							{
								"name": "gt54Inch",
								"qualifiedName": "electronics.tVs.led.gt54Inch",
								"displayName": "> 54 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.led.gt54Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 340,
										"description": "> 54 inch wall mounted LED TV",
										"identifier": 341,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 12
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.led.gt54Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 341,
										"description": "> 54 non-wall mounted LED TV",
										"identifier": 342,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 12
									}
								],
								"score": 340
							}
						],
						"score": 328
					},
					{
						"name": "lcd",
						"qualifiedName": "electronics.tVs.lcd",
						"displayName": "LCD",
						"children": [
							{
								"name": "lt24Inch",
								"qualifiedName": "electronics.tVs.lcd.lt24Inch",
								"displayName": "< 24 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.lt24Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 342,
										"description": "< 24 inch wall mounted LCD TV",
										"identifier": 343,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 7
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.lt24Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 343,
										"description": "< 24 inch non-wall mounted LCD TV",
										"identifier": 344,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 7
									}
								],
								"score": 342
							},
							{
								"name": "24Hyphen31Inch",
								"qualifiedName": "electronics.tVs.lcd.24Hyphen31Inch",
								"displayName": "24-31 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.24Hyphen31Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 344,
										"description": "24-31 inch wall mounted LCD TV",
										"identifier": 345,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.24Hyphen31Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 345,
										"description": "24-31 inch non-wall mounted LCD TV",
										"identifier": 346,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									}
								],
								"score": 344
							},
							{
								"name": "32Inch",
								"qualifiedName": "electronics.tVs.lcd.32Inch",
								"displayName": "32 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.32Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 346,
										"description": "32 inch wall mounted LCD TV",
										"identifier": 347,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.32Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 347,
										"description": "32 inch non-wall mounted LCD TV",
										"identifier": 348,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 8
									}
								],
								"score": 346
							},
							{
								"name": "33Hyphen39Inch",
								"qualifiedName": "electronics.tVs.lcd.33Hyphen39Inch",
								"displayName": "33-39 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.33Hyphen39Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 348,
										"description": "33-39 inch wall mounted LCD TV",
										"identifier": 349,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.33Hyphen39Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 349,
										"description": "33-39 inch non-wall mounted LCD TV",
										"identifier": 350,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									}
								],
								"score": 348
							},
							{
								"name": "40Hyphen42Inch",
								"qualifiedName": "electronics.tVs.lcd.40Hyphen42Inch",
								"displayName": "40-42 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.40Hyphen42Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 350,
										"description": "40-42 inch wall mounted LCD TV",
										"identifier": 351,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.40Hyphen42Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 351,
										"description": "40-42 inch non-wall mounted LCD TV",
										"identifier": 352,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 10
									}
								],
								"score": 350
							},
							{
								"name": "43Hyphen54Inch",
								"qualifiedName": "electronics.tVs.lcd.43Hyphen54Inch",
								"displayName": "43-54 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.43Hyphen54Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 352,
										"description": "43-54 inch wall mounted LCD TV",
										"identifier": 353,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 11
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.43Hyphen54Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 353,
										"description": "43-54 inch non-wall mounted LCD TV",
										"identifier": 354,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 11
									}
								],
								"score": 352
							},
							{
								"name": "gt54Inch",
								"qualifiedName": "electronics.tVs.lcd.gt54Inch",
								"displayName": ">54 inch",
								"children": [
									{
										"name": "wallMounted",
										"qualifiedName": "electronics.tVs.lcd.gt54Inch.wallMounted",
										"displayName": "Wall mounted",
										"children": [],
										"score": 354,
										"description": "> 54 inch wall mounted LCD TV",
										"identifier": 355,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 12
									},
									{
										"name": "nonhyphenwallMounted",
										"qualifiedName": "electronics.tVs.lcd.gt54Inch.nonhyphenwallMounted",
										"displayName": "Non-wall mounted",
										"children": [],
										"score": 355,
										"description": "> 54 non-wall mounted LCD TV",
										"identifier": 356,
										"item_id": 33,
										"version": "2",
										"cubic_feet": 12
									}
								],
								"score": 354
							}
						],
						"score": 342
					},
					{
						"name": "crt",
						"qualifiedName": "electronics.tVs.crt",
						"displayName": "CRT",
						"children": [
							{
								"name": "lte14Inch",
								"qualifiedName": "electronics.tVs.crt.lte14Inch",
								"displayName": "<= 14 inch",
								"children": [],
								"score": 356,
								"description": "<= 14 inch CRT TV",
								"identifier": 357,
								"item_id": 33,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "15Hyphen21Inch",
								"qualifiedName": "electronics.tVs.crt.15Hyphen21Inch",
								"displayName": "15 – 21 inch",
								"children": [],
								"score": 357,
								"description": "15 – 21 inch CRT TV",
								"identifier": 358,
								"item_id": 33,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "22Hyphen28Inch",
								"qualifiedName": "electronics.tVs.crt.22Hyphen28Inch",
								"displayName": "22 – 28 inch",
								"children": [],
								"score": 358,
								"description": "22 – 28 inch CRT TV",
								"identifier": 359,
								"item_id": 33,
								"version": "2",
								"cubic_feet": 13
							},
							{
								"name": "gt28Inch",
								"qualifiedName": "electronics.tVs.crt.gt28Inch",
								"displayName": "> 28 inch",
								"children": [],
								"score": 359,
								"description": "> 28 inch CRT TV",
								"identifier": 360,
								"item_id": 33,
								"version": "2",
								"cubic_feet": 20
							}
						],
						"score": 356
					}
				],
				"score": 328,
				"item_id": 33
			},
			{
				"name": "refrigerators",
				"qualifiedName": "electronics.refrigerators",
				"displayName": "Refrigerators",
				"children": [
					{
						"name": "singleDoor",
						"qualifiedName": "electronics.refrigerators.singleDoor",
						"displayName": "Single door",
						"children": [],
						"score": 360,
						"description": "Single door fridge",
						"identifier": 361,
						"item_id": 32,
						"version": "2",
						"cubic_feet": 18
					},
					{
						"name": "doubleDoor",
						"qualifiedName": "electronics.refrigerators.doubleDoor",
						"displayName": "Double door",
						"children": [],
						"score": 361,
						"description": "Double door fridge",
						"identifier": 362,
						"item_id": 32,
						"version": "2",
						"cubic_feet": 24
					},
					{
						"name": "sideBySide",
						"qualifiedName": "electronics.refrigerators.sideBySide",
						"displayName": "Side by side",
						"children": [],
						"score": 362,
						"description": "Side by side fridge",
						"identifier": 363,
						"item_id": 32,
						"version": "2",
						"cubic_feet": 45
					},
					{
						"name": "tripleDoor",
						"qualifiedName": "electronics.refrigerators.tripleDoor",
						"displayName": "Triple door",
						"children": [],
						"score": 363,
						"description": "Triple door fridge",
						"identifier": 364,
						"item_id": 32,
						"version": "2",
						"cubic_feet": 27
					}
				],
				"score": 360,
				"item_id": 32
			},
			{
				"name": "washingMachines",
				"qualifiedName": "electronics.washingMachines",
				"displayName": "Washing machines",
				"children": [
					{
						"name": "topLoading",
						"qualifiedName": "electronics.washingMachines.topLoading",
						"displayName": "Top loading",
						"children": [
							{
								"name": "automatic",
								"qualifiedName": "electronics.washingMachines.topLoading.automatic",
								"displayName": "Automatic",
								"children": [],
								"score": 364,
								"description": "Automatic top loading washing machine",
								"identifier": 365,
								"item_id": 31,
								"version": "2",
								"cubic_feet": 15
							},
							{
								"name": "semiAutomatic",
								"qualifiedName": "electronics.washingMachines.topLoading.semiAutomatic",
								"displayName": "Semi automatic",
								"children": [],
								"score": 365,
								"description": "Semi automatic top loading washing machine",
								"identifier": 366,
								"item_id": 31,
								"version": "2",
								"cubic_feet": 11
							}
						],
						"score": 364
					},
					{
						"name": "frontLoading",
						"qualifiedName": "electronics.washingMachines.frontLoading",
						"displayName": "Front loading",
						"children": [],
						"score": 366,
						"description": "Front loading washing machine",
						"identifier": 367,
						"item_id": 31,
						"version": "2",
						"cubic_feet": 15
					}
				],
				"score": 364,
				"item_id": 31
			},
			{
				"name": "ovens",
				"qualifiedName": "electronics.ovens",
				"displayName": "Ovens",
				"children": [
					{
						"name": "microwave",
						"qualifiedName": "electronics.ovens.microwave",
						"displayName": "Microwave",
						"children": [],
						"score": 367,
						"description": "Microwave oven",
						"identifier": 368,
						"item_id": 30,
						"version": "2",
						"cubic_feet": 6
					},
					{
						"name": "otg",
						"qualifiedName": "electronics.ovens.otg",
						"displayName": "Otg",
						"children": [],
						"score": 368,
						"description": "OTG oven",
						"identifier": 369,
						"item_id": 30,
						"version": "2",
						"cubic_feet": 6
					},
					{
						"name": "cookingRange",
						"qualifiedName": "electronics.ovens.cookingRange",
						"displayName": "Cooking range",
						"children": [],
						"score": 369,
						"description": "Cooking range",
						"identifier": 370,
						"item_id": 30,
						"version": "2",
						"cubic_feet": 10
					}
				],
				"score": 367,
				"item_id": 30
			},
			{
				"name": "airConditioners",
				"qualifiedName": "electronics.airConditioners",
				"displayName": "Air conditioners",
				"children": [
					{
						"name": "window",
						"qualifiedName": "electronics.airConditioners.window",
						"displayName": "Window",
						"children": [
							{
								"name": "lt1Ton",
								"qualifiedName": "electronics.airConditioners.window.lt1Ton",
								"displayName": "< 1 ton",
								"children": [],
								"score": 370,
								"description": "< 1 ton window A/C",
								"identifier": 371,
								"item_id": 29,
								"version": "2",
								"cubic_feet": 8
							},
							{
								"name": "1Hyphen15Ton",
								"qualifiedName": "electronics.airConditioners.window.1Hyphen15Ton",
								"displayName": "1 - 1.5 ton",
								"children": [],
								"score": 371,
								"description": "1 - 1.5 ton window A/C",
								"identifier": 372,
								"item_id": 29,
								"version": "2",
								"cubic_feet": 8
							},
							{
								"name": "15Hyphen2Ton",
								"qualifiedName": "electronics.airConditioners.window.15Hyphen2Ton",
								"displayName": "1.5 – 2 ton",
								"children": [],
								"score": 372,
								"description": "1.5 – 2 ton window A/C",
								"identifier": 373,
								"item_id": 29,
								"version": "2",
								"cubic_feet": 8
							}
						],
						"score": 370
					},
					{
						"name": "split",
						"qualifiedName": "electronics.airConditioners.split",
						"displayName": "Split",
						"children": [
							{
								"name": "lt1Ton",
								"qualifiedName": "electronics.airConditioners.split.lt1Ton",
								"displayName": "< 1 ton",
								"children": [],
								"score": 373,
								"description": "< 1 ton split A/C",
								"identifier": 374,
								"item_id": 29,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "1Hyphen15Ton",
								"qualifiedName": "electronics.airConditioners.split.1Hyphen15Ton",
								"displayName": "1 - 1.5 ton",
								"children": [],
								"score": 374,
								"description": "1 - 1.5 ton split A/C",
								"identifier": 375,
								"item_id": 29,
								"version": "2",
								"cubic_feet": 10
							},
							{
								"name": "15Hyphen2Ton",
								"qualifiedName": "electronics.airConditioners.split.15Hyphen2Ton",
								"displayName": "1.5 – 2 ton",
								"children": [],
								"score": 375,
								"description": "1.5 – 2 ton split A/C",
								"identifier": 376,
								"item_id": 29,
								"version": "2",
								"cubic_feet": 10
							}
						],
						"score": 373
					}
				],
				"score": 370,
				"item_id": 29
			},
			{
				"name": "fansCoolers",
				"qualifiedName": "electronics.fansCoolers",
				"displayName": "Fans / coolers",
				"children": [
					{
						"name": "towerCooler",
						"qualifiedName": "electronics.fansCoolers.towerCooler",
						"displayName": "Tower cooler",
						"children": [],
						"score": 376,
						"description": "Tower cooler",
						"identifier": 377,
						"item_id": 28,
						"version": "2",
						"cubic_feet": 14
					},
					{
						"name": "ceilingFan",
						"qualifiedName": "electronics.fansCoolers.ceilingFan",
						"displayName": "Ceiling fan",
						"children": [],
						"score": 377,
						"description": "Celling fan",
						"identifier": 378,
						"item_id": 28,
						"version": "2",
						"cubic_feet": 3
					},
					{
						"name": "tableFan",
						"qualifiedName": "electronics.fansCoolers.tableFan",
						"displayName": "Table fan",
						"children": [],
						"score": 378,
						"description": "Table fan",
						"identifier": 379,
						"item_id": 28,
						"version": "2",
						"cubic_feet": 2
					},
					{
						"name": "pedestalFan",
						"qualifiedName": "electronics.fansCoolers.pedestalFan",
						"displayName": "Pedestal fan",
						"children": [],
						"score": 379,
						"description": "Pedestal fan",
						"identifier": 380,
						"item_id": 28,
						"version": "2",
						"cubic_feet": 10
					},
					{
						"name": "wallMountedFan",
						"qualifiedName": "electronics.fansCoolers.wallMountedFan",
						"displayName": "Wall mounted fan",
						"children": [],
						"score": 380,
						"description": "Wall mounted fan",
						"identifier": 381,
						"item_id": 28,
						"version": "2",
						"cubic_feet": 2
					}
				],
				"score": 376,
				"item_id": 28
			}
		]
	},
	{
		"name": "others",
		"qualifiedName": "others",
		"displayName": "Others",
		"children": [
			{
				"name": "utility",
				"qualifiedName": "others.utility",
				"displayName": "Utility",
				"children": [
					{
						"name": "cartonBoxes",
						"qualifiedName": "others.utility.cartonBoxes",
						"displayName": "Carton boxes",
						"children": [],
						"score": 381,
						"description": "Carton_box",
						"identifier": 382,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "waterDrums",
						"qualifiedName": "others.utility.waterDrums",
						"displayName": "Water drums",
						"children": [],
						"score": 382,
						"description": "Water drum",
						"identifier": 383,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 20
					},
					{
						"name": "cribs",
						"qualifiedName": "others.utility.cribs",
						"displayName": "Cribs",
						"children": [],
						"score": 383,
						"description": "Crib",
						"identifier": 384,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 15
					},
					{
						"name": "lpgCylinders",
						"qualifiedName": "others.utility.lpgCylinders",
						"displayName": "Lpg cylinders",
						"children": [],
						"score": 384,
						"description": "Lpg cylinder",
						"identifier": 385,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "trunksSuitcases",
						"qualifiedName": "others.utility.trunksSuitcases",
						"displayName": "Trunks/suitcases",
						"children": [],
						"score": 385,
						"description": "Steel trunk",
						"identifier": 386,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 12
					},
					{
						"name": "inverterBatteries",
						"qualifiedName": "others.utility.inverterBatteries",
						"displayName": "Inverter+batteries",
						"children": [],
						"score": 386,
						"description": "Inverter+battries",
						"identifier": 387,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 10
					},
					{
						"name": "kitchenRacks",
						"qualifiedName": "others.utility.kitchenRacks",
						"displayName": "Kitchen racks",
						"children": [],
						"score": 387,
						"description": "Kitchen rack",
						"identifier": 388,
						"item_id": 27,
						"version": "2",
						"cubic_feet": 9
					}
				],
				"score": 381,
				"item_id": 27
			},
			{
				"name": "homeAppliances",
				"qualifiedName": "others.homeAppliances",
				"displayName": "Home appliances",
				"children": [
					{
						"name": "wetGrinders",
						"qualifiedName": "others.homeAppliances.wetGrinders",
						"displayName": "Wet grinders",
						"children": [],
						"score": 388,
						"description": "Wet grinder",
						"identifier": 389,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "waterPurifiers",
						"qualifiedName": "others.homeAppliances.waterPurifiers",
						"displayName": "Water purifiers",
						"children": [],
						"score": 389,
						"description": "Water purifier",
						"identifier": 390,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 5
					},
					{
						"name": "vacuumCleaners",
						"qualifiedName": "others.homeAppliances.vacuumCleaners",
						"displayName": "Vacuum cleaners",
						"children": [],
						"score": 390,
						"description": "Vacuum cleaner",
						"identifier": 391,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 8
					},
					{
						"name": "dishWashers",
						"qualifiedName": "others.homeAppliances.dishWashers",
						"displayName": "Dish washers",
						"children": [],
						"score": 391,
						"description": "Dish washer",
						"identifier": 392,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 12
					},
					{
						"name": "desktops",
						"qualifiedName": "others.homeAppliances.desktops",
						"displayName": "Desktops",
						"children": [],
						"score": 392,
						"description": "Desk top",
						"identifier": 393,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 8
					},
					{
						"name": "sewingMachines",
						"qualifiedName": "others.homeAppliances.sewingMachines",
						"displayName": "Sewing machines",
						"children": [],
						"score": 393,
						"description": "Sewing machine",
						"identifier": 394,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 10
					},
					{
						"name": "stoves",
						"qualifiedName": "others.homeAppliances.stoves",
						"displayName": "Stoves",
						"children": [],
						"score": 394,
						"description": "Stove",
						"identifier": 395,
						"item_id": 26,
						"version": "2",
						"cubic_feet": 4
					}
				],
				"score": 388,
				"item_id": 26
			},
			{
				"name": "specialCareItems",
				"qualifiedName": "others.specialCareItems",
				"displayName": "Special care items",
				"children": [
					{
						"name": "paintingFrames",
						"qualifiedName": "others.specialCareItems.paintingFrames",
						"displayName": "Painting/frames",
						"children": [],
						"score": 395,
						"description": "Painting/frames",
						"identifier": 396,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 6
					},
					{
						"name": "crockerySets",
						"qualifiedName": "others.specialCareItems.crockerySets",
						"displayName": "Crockery sets",
						"children": [],
						"score": 396,
						"description": "Crockery",
						"identifier": 397,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 5
					},
					{
						"name": "homeTheatres",
						"qualifiedName": "others.specialCareItems.homeTheatres",
						"displayName": "Home theatres",
						"children": [],
						"score": 397,
						"description": "Home theatre",
						"identifier": 398,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 8
					},
					{
						"name": "showPieces",
						"qualifiedName": "others.specialCareItems.showPieces",
						"displayName": "Show pieces",
						"children": [],
						"score": 398,
						"description": "Show piece",
						"identifier": 399,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 5
					},
					{
						"name": "barCabinets",
						"qualifiedName": "others.specialCareItems.barCabinets",
						"displayName": "Bar cabinets",
						"children": [],
						"score": 399,
						"description": "Bar cabinet",
						"identifier": 400,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 34
					},
					{
						"name": "lamps",
						"qualifiedName": "others.specialCareItems.lamps",
						"displayName": "Lamps",
						"children": [],
						"score": 400,
						"description": "Lamp",
						"identifier": 401,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 10
					},
					{
						"name": "temples",
						"qualifiedName": "others.specialCareItems.temples",
						"displayName": "Temples",
						"children": [],
						"score": 401,
						"description": "Temple",
						"identifier": 402,
						"item_id": 25,
						"version": "2",
						"cubic_feet": 15
					}
				],
				"score": 395,
				"item_id": 25
			},
			{
				"name": "funAndFitness",
				"qualifiedName": "others.funAndFitness",
				"displayName": "Fun and fitness",
				"children": [
					{
						"name": "swings",
						"qualifiedName": "others.funAndFitness.swings",
						"displayName": "Swings",
						"children": [],
						"score": 402,
						"description": "Swing",
						"identifier": 403,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "exerciseCycles",
						"qualifiedName": "others.funAndFitness.exerciseCycles",
						"displayName": "Exercise cycles",
						"children": [],
						"score": 403,
						"description": "Exercise cycle",
						"identifier": 404,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 12
					},
					{
						"name": "treadMills",
						"qualifiedName": "others.funAndFitness.treadMills",
						"displayName": "Tread mills",
						"children": [],
						"score": 404,
						"description": "Tread mill",
						"identifier": 405,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 45
					},
					{
						"name": "infantCycles",
						"qualifiedName": "others.funAndFitness.infantCycles",
						"displayName": "Infant cycles",
						"children": [],
						"score": 405,
						"description": "Infant cycle",
						"identifier": 406,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "flowerPotSmall",
						"qualifiedName": "others.funAndFitness.flowerPotSmall",
						"displayName": "Flower pot small",
						"children": [],
						"score": 406,
						"description": "Flower Pot Small",
						"identifier": 407,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 2
					},
					{
						"name": "flowerPotLarge",
						"qualifiedName": "others.funAndFitness.flowerPotLarge",
						"displayName": "Flower pot large",
						"children": [],
						"score": 407,
						"description": "Flower Pot Large",
						"identifier": 408,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 4
					},
					{
						"name": "beanBags",
						"qualifiedName": "others.funAndFitness.beanBags",
						"displayName": "Bean bags",
						"children": [],
						"score": 408,
						"description": "Bean bag",
						"identifier": 409,
						"item_id": 24,
						"version": "2",
						"cubic_feet": 6
					}
				],
				"score": 402,
				"item_id": 24
			}
		]
	},
	{
		"name": "",
		"qualifiedName": "",
		"displayName": "",
		"children": [],
		"description": "Cycle",
		"identifier": 412,
		"item_id": -1,
		"version": "1111",
		"cubic_feet": 10
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./client/app/common/inventory/ITEM_INVENTORY.json
// module id = 206
// module chunks = 0